"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidateItem = exports.TitleTextBlock = exports.Title = exports.TextSmall = exports.Text = exports.EditButton = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: #1d2526;\n  padding: 25px 25px 4em;\n  position: relative;\n  .ra-DIX h3,\n  .ra-DIX ul,\n  .ra-DIX p {\n    margin-left: 3px;\n  }\n"])));
exports.Container = Container;
var TitleTextBlock = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  p,\n  h3 {\n    display: inline-block;\n  }\n  h3 {\n    color: #2f1747;\n    margin-right: 5px;\n  }\n  ", "\n"])), function (_ref) {
  var $bsStyle = _ref.$bsStyle;
  return $bsStyle || '';
});
exports.TitleTextBlock = TitleTextBlock;
var EditButton = _styledComponents.default.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding-right: 5px;\n  display: flex;\n  flex-direction: column;\n  border: none;\n  background: transparent;\n"])));
exports.EditButton = EditButton;
var TextSmall = _styledComponents.default.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 130%;\n  margin-bottom: 0;\n  .strong {\n    font-family: 'Gentleman', Arial, sans-serif;\n    font-weight: 800;\n  }\n"])));
exports.TextSmall = TextSmall;
var Title = _styledComponents.default.h3(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-family: 'Gentleman', Arial, sans-serif;\n  font-weight: 800;\n  font-style: normal;\n  line-height: 113%;\n  font-size: 17px;\n  display: inline-block;\n  margin-bottom: 0;\n  color: ", ";\n  ", "\n"])), function (_ref2) {
  var color = _ref2.color;
  return color || '#000';
}, function (_ref3) {
  var $bsStyle = _ref3.$bsStyle;
  return $bsStyle || '';
});
exports.Title = Title;
var Text = _styledComponents.default.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 130%;\n  margin-bottom: 2px;\n  font-family: 'Gentleman', Arial, sans-serif;\n  ", ";\n  ", ";\n  ", ";\n"])), function (_ref4) {
  var strong = _ref4.strong;
  return strong ? 'font-weight: 800;' : '';
}, function (_ref5) {
  var italic = _ref5.italic;
  return italic ? 'font-style: italic;;' : '';
}, function (_ref6) {
  var $bsStyle = _ref6.$bsStyle;
  return $bsStyle || '';
});
exports.Text = Text;
var getDisplay = function getDisplay(variant) {
  if (variant === 'li') {
    return 'list-item';
  }
  return 'block';
};
var ValidateItem = _styledComponents.default.div.attrs(function (_ref7) {
  var variant = _ref7.variant;
  return {
    as: variant || 'div'
  };
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: ", ";\n  ", ";\n"])), function (_ref8) {
  var show = _ref8.show,
    variant = _ref8.variant;
  return show ? getDisplay(variant) : 'none';
}, function (_ref9) {
  var $bsStyle = _ref9.$bsStyle;
  return $bsStyle || '';
});
exports.ValidateItem = ValidateItem;